import { IconFont } from '@byecode/ui'
import type { SchemaProtocol, ViewFieldProtocol } from '@lighthouse/core'
import { getFieldIcon, ListItem4ByecodeUi } from '@lighthouse/shared'
import type { ChangeEvent } from 'react'
import React, { useCallback, useMemo } from 'react'

import * as SC from './styles'

interface BaseViewFieldConfigProps {
    value: ViewFieldProtocol
    schema: SchemaProtocol['schema']
    onChange?: (val: ViewFieldProtocol) => void
}

export const BaseViewFieldConfig: React.FC<BaseViewFieldConfigProps> = ({ value, schema, onChange }) => {
    const { type, title, fieldId, innerType } = value
    const dataSourceField = useMemo(() => schema[fieldId], [fieldId, schema])
    const handleChange = useCallback(
        (val: string) => {
            onChange?.({
                ...value,
                title: val
            })
        },
        [onChange, value]
    )
    const icon = useMemo(() => getFieldIcon(fieldId, type, innerType), [fieldId, innerType, type])

    return (
        <SC.Container>
            <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                <SC.FieldIcon>
                    <IconFont size={16} type={icon} />
                </SC.FieldIcon>
                <SC.RightFill>
                    <SC.ViewSettingsInput
                        placeholder="请输入标题"
                        defaultValue={title}
                        styles={{ wrapper: { width: '100%' } }}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange(e.target.value)}
                    />
                </SC.RightFill>
            </ListItem4ByecodeUi>
            <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                <SC.Text color="var(--color-gray-600)">字段</SC.Text>
                <SC.Text>{dataSourceField?.name}</SC.Text>
            </ListItem4ByecodeUi>
        </SC.Container>
    )
}
